import { Group, Table, Text } from '@mantine/core';

type GroupHeaderRowProps = {
  pageId: string;
};

export const GroupHeaderRow = ({ pageId }: GroupHeaderRowProps) => (
  <Table.Tr>
    <Table.Td colSpan={10}>
      <Group align="center">
        <Text>Expert Page:</Text>
        <Text>{pageId}</Text>
      </Group>
    </Table.Td>
  </Table.Tr>
);
